@let organizationNameValue = organizationName();
@let userFullNameValue = userFullName();

<div class="impersonate-banner__container">
  <div class="impersonate-banner__text">
    <span>{{ 'impersonate.banner.text' | translate }}</span>
    @if (!!userFullNameValue && !!organizationNameValue) {
      <span class="impersonate-banner__text-bold">{{ userFullNameValue }}</span>
      <span>{{ 'impersonate.banner.from' | translate }}</span>
      <span class="impersonate-banner__text-bold">{{ organizationNameValue }}</span>
    } @else {
      <kds-spinner [style.--spinner-color]="spinnerColor" />
    }
  </div>

  <div class="impersonate-banner__button" (click)="logOut()">{{ 'impersonate.banner.button' | translate }}</div>
</div>
